import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { API, carsUrl, authFetch } from '../utils/api';
import { getSocket } from '../utils/socket';
import { enter as presenceEnter, leave as presenceLeave, createChannel as createPresenceChannel, mySid as presenceMySid, presenceOthersLabeled } from '../utils/carPresence';
import { getYearFromVin } from '../utils/vinDecoder';
import { wonFromMan, manFromWon } from '../utils/format';
import { FLOW, FLOW_COLOR, DOC_NAMES } from '../utils/documentTypes';
import { getEngCarName } from '../utils/carNames';
import { printContract as printContractUtil } from '../utils/contractPrint';
import { carEditDiff } from '../v2/cars/carEditDiff';
import PresenceBanner from './PresenceBanner';
import UploadPopup from './UploadPopup';
import CarListTable from './CarListTable';
import CarListCards from './CarListCards';
import CarListModals from './CarListModals';
import CarListToolbar from './CarListToolbar';
import CustomModal from './CustomModal';
import CompanyListPanel from './CompanyListPanel';

function CarListPage({showToast,openDoc,openInvoice,user}){
  var isAgency=user&&(user.role==='doc_agency'||user.role==='cancel_agency');
  var isAdmin=user&&(user.role==='관리자'||user.role==='admin');
  var isDocAgency=user&&user.role==='doc_agency';
  var showCompanyFilter=isAdmin||isDocAgency;
  var[filterCompanyId,setFilterCompanyId]=useState((isAdmin||isDocAgency)&&user?(user.activeCompanyId||user.companyId||''):'');
  var [modal,setModal]=useState(null);
  var closeModal=function(){setModal(null)};
  var[cars,setCars]=useState([]);var[search,setSr]=useState('');var[filter,setFl]=useState('전체');var[saleFilter,setSaleFilter]=useState('전체');var[buyerFilter,setBuyerFilter]=useState('전체');var[buyerList,setBuyerList]=useState([]);
  var[uploadCar,setUploadCar]=useState(null);var[checkedIds,setCheckedIds]=useState([]);var[docDetailCar,setDocDetailCar]=useState(null);var[docDropCar,setDocDropCar]=useState(null);var[docDropPos,setDocDropPos]=useState({top:0,left:0});
  var[viewMode,setViewMode]=useState('table');var[uploadingPhotoId,setUploadingPhotoId]=useState(null);
  var[clearDocModal,setClearDocModal]=useState(null);var[clearDocTab,setClearDocTab]=useState('correction');
  var[clearDocData,setClearDocData]=useState({docDate:new Date().toISOString().slice(0,10),exportDecNo:'',reason:'',customReason:'',beforeVal:'',afterVal:'',vin:'',beforeCompany:'',beforeBizNo:'',afterCompany:'',afterBizNo:'',vehicleInfo:'',vehicleLocation:'',carNo:''});
  var[clearDocLoading,setClearDocLoading]=useState(false);var[clearDocEmail,setClearDocEmail]=useState('');var[clearDocSending,setClearDocSending]=useState(false);
  var[companyInfo,setCompanyInfo]=useState({companyName:'',ceo:'',addr:'',tel:''});
  var[companiesList,setCompaniesList]=useState([]);
  var[page,setPage]=useState(1);var[perPage,setPerPage]=useState(20);
  // 정렬 상태 — 회사별 격리 (filterCompanyId 또는 user.activeCompanyId 기준)
  var _sortKeyCid=function(){var c=parseInt(filterCompanyId)||(user&&(user.activeCompanyId||user.companyId))||0;return 'autodoc_carlist_sort_'+c};
  var[sortKey,setSortKey]=useState(function(){try{return sessionStorage.getItem(_sortKeyCid()+'_key')||'purchaseDate'}catch(e){return 'purchaseDate'}});
  var[sortDir,setSortDir]=useState(function(){try{return sessionStorage.getItem(_sortKeyCid()+'_dir')||'desc'}catch(e){return 'desc'}});
  // 회사 전환 시 해당 회사의 저장된 정렬 상태로 복원 (먼저 실행되어야 함)
  var _sortLoadedCidRef=useRef(_sortKeyCid());
  useEffect(function(){try{var k=_sortKeyCid();_sortLoadedCidRef.current=k;setSortKey(sessionStorage.getItem(k+'_key')||'purchaseDate');setSortDir(sessionStorage.getItem(k+'_dir')||'desc')}catch(e){}},[filterCompanyId]);
  // sortKey/sortDir 변경 시 현재 회사 키에만 저장 (로드 직후의 echo를 방지하기 위해 ref와 비교)
  useEffect(function(){try{var k=_sortKeyCid();if(k===_sortLoadedCidRef.current){sessionStorage.setItem(k+'_key',sortKey||'');sessionStorage.setItem(k+'_dir',sortDir||'asc')}}catch(e){}},[sortKey,sortDir]);
  var[showScrollTop,setShowScrollTop]=useState(false);
  var[bulkDlOpen,setBulkDlOpen]=useState(false);var[bulkDlLoading,setBulkDlLoading]=useState(false);var[bulkDlChecked,setBulkDlChecked]=useState([]);
  var[bulkPrintOpen,setBulkPrintOpen]=useState(false);var[bulkPrintLoading,setBulkPrintLoading]=useState(false);var[bulkPrintChecked,setBulkPrintChecked]=useState([]);
  // 체크박스 비워지면 일괄다운로드/프린트 드롭다운 자동 닫기 (stale state 방지)
  useEffect(function(){if(checkedIds.length===0){setBulkDlOpen(false);setBulkPrintOpen(false);}},[checkedIds.length]);
  var[carPhotos,setCarPhotos]=useState({});var[selectedPhotosCar,setSelectedPhotosCar]=useState(null);var[dragPhotoIdx,setDragPhotoIdx]=useState(null);var[dragOverIdx,setDragOverIdx]=useState(null);
  // 현장계약서 (단일 또는 다중 차량)
  var[contractCars,setContractCars]=useState([]);var[contractPrices,setContractPrices]=useState({});
  var[contractBuyerName,setContractBuyerName]=useState('');var[contractBuyerPhone,setContractBuyerPhone]=useState('');
  var[contractDeposit,setContractDeposit]=useState('');
  var[contractBankInfo,setContractBankInfo]=useState(function(){return localStorage.getItem('contract_bankInfo')||''});
  var[contractDocPhone,setContractDocPhone]=useState(function(){return localStorage.getItem('contract_docPhone')||''});
  // 차량 수정 모달
  var[editCar,setEditCar]=useState(null);
  var[editForm,setEditForm]=useState({});
  var[editSaving,setEditSaving]=useState(false);
  // 저장 diff 기준 — 모달을 열 때(·재조회 때) 받은 /full 스냅샷과 그때의 주민번호 입력칸 (v2/cars/carEditDiff.js)
  var[editBaseForm,setEditBaseForm]=useState({});
  var[editBaseIds,setEditBaseIds]=useState({});
  var[editOwnerIdFront,setEditOwnerIdFront]=useState('');
  var[editOwnerIdBack,setEditOwnerIdBack]=useState('');
  var[editOwner2IdFront,setEditOwner2IdFront]=useState('');
  var[editOwner2IdBack,setEditOwner2IdBack]=useState('');
  var[editBuyers,setEditBuyers]=useState([]);
  var[editTimeline,setEditTimeline]=useState(null);
  // #343: 동시 편집 프레즌스 — {carId: users[]}. users 는 **접속(소켓) 단위**라 본인 접속(sid)만 빼고,
  // 같은 계정의 다른 접속(PC↔모바일)은 "(PC)"/"(모바일)" 을 붙여 남긴다 (utils/carPresence).
  var[presenceByCar,setPresenceByCar]=useState({});
  // 구독 + 목록 요청을 한 채널로 묶는다 — 스냅샷을 "이 화면이 요청한 id" 로 거르는 주체가 팩토리다.
  var presenceChanRef=useRef(null);
  if(!presenceChanRef.current)presenceChanRef.current=createPresenceChannel();
  var presenceChan=presenceChanRef.current;
  var currentUserId=user&&user.id;
  // 내 socket.id 는 렌더당 1회만 읽는다 — 행마다 부르면 500행 목록에서 getSocket() 이 500번 불린다.
  var mySid=presenceMySid();
  var othersForCar=function(carId){
    return presenceOthersLabeled(presenceByCar[carId]||[],mySid,currentUserId);
  };
  // 수정 모달 상단 배너 — 마크업은 components/PresenceBanner.js 한 벌, 자식은 받아 렌더만 한다.
  var presenceBanner=function(carId){
    return <PresenceBanner users={othersForCar(carId)} target="이 차량" action="수정 중" />;
  };
  // 프레즌스 이벤트 구독 — car:presence(단건 변화, 회사 룸 전체) / car:presence:snapshot(list 요청 응답)
  // 서버 미배포/구 서버면 getSocket 이벤트가 안 와서 presenceByCar 는 항상 빈 채로 유지된다(표시 없음, 에러 없음).
  useEffect(function(){
    var unsub=presenceChan.subscribe(function(evt){
      if(evt.type==='presence'){
        var p=evt.payload||{};
        if(!p.carId)return;
        setPresenceByCar(function(prev){var n=Object.assign({},prev);n[p.carId]=p.users||[];return n});
      } else if(evt.type==='snapshot'){
        // 팩토리가 이 채널이 요청한 id 로 걸러 넘긴다 — 담겨 온 것만 반영하고, 값이 비었으면
        // "이제 아무도 없다"로 지운다 (프레즌스 3종 4화면 공통 코드).
        var snap=evt.payload||{};
        setPresenceByCar(function(prev){
          var n=Object.assign({},prev);
          Object.keys(snap).forEach(function(id){if(snap[id]&&snap[id].length)n[id]=snap[id];else delete n[id];});
          return n;
        });
      }
    });
    return unsub;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);
  // 차량 수정 모달 열림/닫힘(닫기 버튼·저장 성공·뒤로가기·언마운트 전부 editCar 상태변화로 수렴)에
  // enter/leave 를 동기화. cleanup 이 이전 id 를 leave 하므로 모든 닫기 경로 + 언마운트에서 자동 호출된다.
  useEffect(function(){
    if(!editCar)return;
    var id=editCar.id;
    presenceEnter(id);
    return function(){presenceLeave(id)};
  },[editCar?editCar.id:null]);
  // 차량 상세 모달의 editForm 디폴트 매핑 (단일 진실 원천)
  // ⚠️ 새 컬럼 추가 시 여기 한 곳만 수정하면 됨
  var EDIT_FORM_FIELDS={
    // [필드명, 디폴트값]
    carNo:'',vin:'',carType:'',usage2:'자가용',owner:'',owner2:'',ownerAddr:'',regDate:'',mileage:0,
    buyPrice:0,sellPrice:0,invoice_amount:0,exporter:'',country:'',status:'등록완료',buyerId:0,
    photoUrl:'',isPublic:0,buyAddress:'',buyRegion:'',buyDate:'',buySource:'',
    transportFee:0,fuelFee:0,cancelFee:0,clearanceFee:0,otherFee:0,
    fuel:'',displacement:'',color:'',purchaseType:'individual',scrap_purchase:0,vatAmount:0,supplyAmount:0,purchaseDate:'',
    companyId:0,owner_payment:0,dealer_payment:0,deposit:0,
    payment_status:'unpaid',payment_completed_at:'',sale_status:'waiting',
    departure_date:'',departure_memo:'',arrived_at:null,
    auto_owner_seal:1,owner_seal_text:'',owner_seal_shape:'',sale_buyer_type:'individual'
  };
  var getDefaultEditForm=function(full){
    var form={};
    Object.keys(EDIT_FORM_FIELDS).forEach(function(k){
      var def=EDIT_FORM_FIELDS[k];
      var v=full?full[k]:undefined;
      // 0/false/'' 같은 falsy도 보존하기 위해 null/undefined만 디폴트로 대체
      form[k]=(v===null||v===undefined)?def:v;
    });
    return form;
  };
  // 열린 상세 모달의 editCar/editForm 을 서버 최신값으로 재동기화 (서류 삭제 후 롤백 반영 등)
  var reloadEditCar=function(carId,opts){
    if(!editCar||editCar.id!==carId)return;
    authFetch(API+'/cars/'+carId+'/full').then(function(r){return r.json()}).then(function(full){
      if(!full||!full.id)return;
      // #343: opts.keepForm — 자기 자신의 직접 PUT(완불/완불취소) 성공 후 재조회. 사용자가
      //   같은 모달에서 계속 입력 중일 수 있어 editForm(입력값)은 건드리지 않고 editCar(version 등)만 갱신.
      if(!(opts&&opts.keepForm))setEditForm(getDefaultEditForm(full));
      if(!(opts&&opts.keepForm))setEditBaseForm(getDefaultEditForm(full));
      setEditCar(full);
    }).catch(function(){});
  };
  var openEditCar=function(c){
    authFetch(API+'/cars/'+c.id+'/timeline').then(function(r){return r.json()}).then(function(d){setEditTimeline(d)}).catch(function(){});
    authFetch(API+'/cars/'+c.id+'/full').then(function(r){return r.json()}).then(function(full){
      var oi=(full.ownerId||'').split('-');
      setEditOwnerIdFront(oi[0]||'');
      var backPart=oi.slice(1).join('-')||'';
      setEditOwnerIdBack(backPart==='*******'?'':backPart);
      var oi2=(full.owner_id2||'').split('-');
      setEditOwner2IdFront(oi2[0]||'');
      var backPart2=oi2.slice(1).join('-')||'';
      setEditOwner2IdBack(backPart2==='*******'?'':backPart2);
      setEditBaseIds({ownerId:{front:oi[0]||'',back:backPart==='*******'?'':backPart},owner_id2:{front:oi2[0]||'',back:backPart2==='*******'?'':backPart2}});
      var f=getDefaultEditForm(full);setEditForm(f);setEditBaseForm(f);
      setEditCar(full);
      // 모바일 뒤로가기 지원: 히스토리 push
      try { window.history.pushState({carEditModal:true},''); } catch(e) {}
    }).catch(function(){showToast('차량 정보 로딩 실패','err')});
    authFetch(API+'/buyers').then(function(r){return r.json()}).then(function(d){setEditBuyers(d)}).catch(function(){});
  };
  // 모바일 뒤로가기 → 모달 닫기
  useEffect(function(){
    var handler=function(e){if(editCar){setEditCar(null);e.preventDefault()}};
    window.addEventListener('popstate',handler);
    return function(){window.removeEventListener('popstate',handler)};
  },[editCar]);
  var saveEditCar=function(){
    if(!editCar||editSaving)return;
    // 주민번호 결합 — 앞자리만 있고 뒷자리 빈 경우 'front-' 포맷 전송 → 서버 guard(cars-mutate.js)
    // 가 기존 DB값 유지. 둘 다 비면 '' 전송으로 빈 저장. 빈 필드 = 기존 값 유지가 디폴트.
    var _front=(editOwnerIdFront||'').trim();
    var _back=(editOwnerIdBack||'').trim();
    var _oid;
    if(_front&&_back) _oid=_front+'-'+_back;
    else if(_front&&!_back) _oid=_front+'-';
    else _oid='';
    // 공동명의 둘째 주민번호 — ownerId 와 동일 규칙 (앞자리만+뒷자리 빈 → 'front-' 로 서버 keep-existing)
    var _f2=(editOwner2IdFront||'').trim();var _b2=(editOwner2IdBack||'').trim();var _oid2;
    if(_f2&&_b2) _oid2=_f2+'-'+_b2;
    else if(_f2&&!_b2) _oid2=_f2+'-';
    else _oid2='';
    setEditSaving(true);
    // 바뀐 키만 (+ 주민번호는 입력칸이 바뀐 경우만) — 서버는 키 없음 = 기존값 유지
    var body=carEditDiff(editBaseForm,editForm,{
      ownerId:{orig:editBaseIds.ownerId,cur:{front:editOwnerIdFront,back:editOwnerIdBack},value:_oid},
      owner_id2:{orig:editBaseIds.owner_id2,cur:{front:editOwner2IdFront,back:editOwner2IdBack},value:_oid2}
    });
    // #343: 낙관적 락 — editCar.version 이 있을 때만 전송(구 서버/undefined 방어). 서버가
    // WHERE version=? 로 검사해 불일치 시 409 반환(동시 편집 조용한 덮어쓰기 차단).
    if(editCar.version!==undefined&&editCar.version!==null)body.version=editCar.version;
    authFetch(API+'/cars/'+editCar.id,{method:'PUT',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)}).then(function(r){
      return r.json().then(function(d){return {status:r.status,data:d}});
    }).then(function(res){
      setEditSaving(false);
      var d=res.data||{};
      if(res.status===409){
        // 409 두 갈래 — 같은 라우트가 동시 편집 충돌 말고도 거부를 낸다(환급신고 확정 잠금 등).
        // 말소/정산 화면과 같은 모양으로 code 로 가른다.
        if(d.code==='VERSION_CONFLICT'){
          // 다른 사용자가 먼저 저장함 — 내 입력은 버리고 최신본으로 재조회(version 갱신 포함)
          showToast((d.error||'다른 사용자가 이미 수정했습니다')+' — 최신 내용으로 다시 불러왔습니다','err');
          reloadEditCar(editCar.id);
          return;
        }
        // 그 밖의 409 — 서버가 이유를 문구로 준다. 쓰기 자체가 없었으니 재조회하지 않는다.
        showToast(d.error||'저장할 수 없습니다','err');
        return;
      }
      if(d.success){showToast('✅ 차량 정보 수정 완료');setEditCar(null);ld()}
      else showToast('수정 실패: '+(d.error||''),'err');
    }).catch(function(){setEditSaving(false);showToast('서버 오류','err')});
  };
  var ef=function(key,val){setEditForm(function(p){var n=Object.assign({},p);n[key]=val;return n})};
  // 말소 대행 신청 팝업
  var[cancelReqCar,setCancelReqCar]=useState(null);
  var[crAgencies,setCrAgencies]=useState([]);
  var[crAgencyId,setCrAgencyId]=useState('');
  var[crFee,setCrFee]=useState('');
  var[crMemo,setCrMemo]=useState('');
  var[crCancelType,setCrCancelType]=useState('수출말소'); // 말소 사유 (수출말소/폐차말소)
  var[crServices,setCrServices]=useState([]); // 부가서비스 선택 [{serviceId,memo}]
  var[crSubmitting,setCrSubmitting]=useState(false);
  // 차량별 서류 목록 (서버에서 생성된 PDF)
  var[carDocs,setCarDocs]=useState({});
  // loadCarDocs removed: N+1 개별 호출 → batchLoadDocs 사용
  var findDoc=function(carId,docType){
    var docs=carDocs[carId]||[];
    return docs.find(function(d){var base=d.fileName.split('.')[0];return base===docType||base.startsWith(docType+'_')});
  };
  var hasDoc=function(carId,docType){return !!findDoc(carId,docType)};
  var downloadServerDoc=function(carId,docType,carNo){
    var doc=findDoc(carId,docType);
    if(!doc)return;
    var ext=doc.fileName.indexOf('.')!==-1?doc.fileName.substring(doc.fileName.lastIndexOf('.')):'.pdf';
    var name=(carNo||'car')+'_'+(DOC_NAMES[docType]||docType)+ext;
    // Phase 1.5A (2026-05-20): 응답 Content-Type 으로 분기.
    //   - 비-REALTIME 캐시 서류: 서버가 200 JSON {url} (GCS signed URL 또는 /uploads 정적) → 직링크 다운로드.
    //   - REALTIME_DOCS(malso/contract/nonbiz/pumui): 서버가 즉석 PDF buffer → 기존 blob 처리.
    authFetch(API+'/cars/'+carId+'/docs/'+doc.fileName+'?t='+Date.now()).then(function(r){
      var ct=(r.headers&&r.headers.get&&r.headers.get('content-type'))||'';
      if(ct.indexOf('application/json')!==-1){
        return r.json().then(function(j){
          if(!j||!j.url)return;
          // 상대경로(/uploads/...)는 인증 게이트 → native a.href 는 Bearer 미첨부로 401('로그인 필요').
          //   authFetch 로 blob 받아 다운로드 (앱 #125 수정과 동일 논리). 절대 URL(GCS signed)은 기존 직링크.
          if(j.url.charAt(0)==='/'){
            return authFetch(j.url).then(function(r2){return r2.blob()}).then(function(blob){
              var url=URL.createObjectURL(blob);var a=document.createElement('a');a.href=url;a.download=j.filename||name;a.click();URL.revokeObjectURL(url);
            });
          }
          var a=document.createElement('a');a.href=j.url;a.download=j.filename||name;a.click();
        });
      }
      return r.blob().then(function(blob){
        var url=URL.createObjectURL(blob);var a=document.createElement('a');a.href=url;a.download=name;a.click();URL.revokeObjectURL(url);
      });
    }).catch(function(){});
  };

  var location=useLocation();
  var[allCompanyMode,setAllCompanyMode]=useState(false);
  // 월별 필터 기본값: 현재 월 (YYYY-MM). 세무 이월 로직과 동일 — 미말소 차량은 다음 달로 이월
  var[monthFilter,setMonthFilter]=useState(function(){var d=new Date();return d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')});
  // #337: 이월(carry-over) 포함 토글 — 기본 OFF = 이월 제외 (Jin 2026-09-03). ON 시 미말소 이월 포함 (서버 기본).
  var[includeCarryOver,setIncludeCarryOver]=useState(false);
  var ld=function(){
    var url;
    if(allCompanyMode)url=API+'/cars?companyId=all';
    else if(showCompanyFilter&&filterCompanyId)url=API+'/cars?companyId='+filterCompanyId;
    else url=carsUrl(user);
    // 검색어 입력 중에는 월 필터 무시 (전체 DB scope) — 다른 달 차량도 검색 가능
    var searching=(search||'').trim().length>0;
    if(!searching && monthFilter && /^\d{4}-\d{2}$/.test(monthFilter)){
      url+=(url.indexOf('?')>=0?'&':'?')+'ym='+monthFilter;
      // ON 은 서버 기본 동작이라 파라미터 생략. OFF 일 때만 이월 제외 명시.
      if(!includeCarryOver)url+='&includeCarryOver=0';
    }
    authFetch(url).then(function(r){return r.json()}).then(function(d){var arr=Array.isArray(d)?d:[];setCars(arr);batchLoadPhotos(arr);batchLoadDocs(arr);presenceChan.requestList(arr.map(function(c){return c.id}))}).catch(function(){setCars([])})
  };
  // 소켓 핸들러 stale closure 차단 — ldRef.current 가 항상 최신 ld (monthFilter 등 최신 state 캡처)
  //   회귀: deps=[] useEffect 가 첫 렌더의 ld 영구 캡처 → 4월 선택 후 car:updated 발생 시
  //         초기 monthFilter(현재월=5월) 로 fetch → 배경 5월 데이터 + 셀렉터 4월 불일치 (2026-05-16)
  var ldRef=useRef();
  ldRef.current=ld;
  var batchLoadPhotos=function(carList){
    if(!carList||carList.length===0)return;
    var allIds=carList.map(function(c){return c.id});
    var chunks=[];for(var i=0;i<allIds.length;i+=100)chunks.push(allIds.slice(i,i+100));
    chunks.forEach(function(ids){
      authFetch(API+'/cars/batch/photos?ids='+ids.join(',')).then(function(r){return r.json()}).then(function(data){
        setCarPhotos(function(prev){var n=Object.assign({},prev);Object.keys(data).forEach(function(k){n[k]=data[k]});return n});
      }).catch(function(){});
    });
  };
  var batchLoadDocs=function(carList){
    if(!carList||carList.length===0)return;
    var allIds=carList.map(function(c){return c.id});
    var chunks=[];for(var i=0;i<allIds.length;i+=100)chunks.push(allIds.slice(i,i+100));
    chunks.forEach(function(ids){
      authFetch(API+'/cars/batch/docs?ids='+ids.join(',')).then(function(r){return r.json()}).then(function(data){
        setCarDocs(function(prev){var n=Object.assign({},prev);Object.keys(data).forEach(function(k){n[k]=data[k]});return n});
      }).catch(function(){});
    });
  };
  // 마운트 1회 — 부수 데이터 로드 + 라우터 state 처리 (차량 목록은 아래 통합 effect에서 처리)
  useEffect(function(){
    authFetch(API+'/buyers').then(function(r){return r.json()}).then(function(d){setBuyerList(Array.isArray(d)?d:[])}).catch(function(){});
    authFetch(API+'/settings/company').then(function(r){return r.json()}).then(function(d){setCompanyInfo(d)}).catch(function(){});
    authFetch(API+'/settings/companies').then(function(r){return r.json()}).then(function(d){setCompaniesList(d)}).catch(function(){});
    if(location.state){if(location.state.filter)setFl(location.state.filter);if(location.state.search)setSr(location.state.search);if(location.state.buyerId)setBuyerFilter(String(location.state.buyerId))}
  },[]);
  // 차량 목록 로드 — 마운트 + allCompanyMode/filterCompanyId/monthFilter 변경 시 자동 재호출
  useEffect(function(){ld()},[allCompanyMode,filterCompanyId,monthFilter,includeCarryOver]);
  // 검색어 변경 시 300ms debounce 후 재fetch — search 가 있으면 ld() 가 ym 빼고 전체 fetch
  // (마운트 시에도 1회 트리거되지만 위 useEffect 와 거의 동시 → 사실상 idempotent)
  useEffect(function(){var t=setTimeout(function(){ld()},300);return function(){clearTimeout(t)}},[search]);
  // WebSocket 실시간 갱신 — ldRef.current 경유로 최신 monthFilter/companyId 반영
  useEffect(function(){var s=getSocket();if(!s)return;var handler=function(){ldRef.current&&ldRef.current()};s.on('car:updated',handler);s.on('car:statusChanged',handler);s.on('doc:uploaded',handler);s.on('doc:generated',handler);return function(){s.off('car:updated',handler);s.off('car:statusChanged',handler);s.off('doc:uploaded',handler);s.off('doc:generated',handler)}},[]);
  // 서류 드롭다운 외부 클릭 닫기 (상시 리스너)
  useEffect(function(){var h=function(e){if(!e.target.closest('.doc-drop-zone'))setDocDropCar(null)};var s=function(e){if(e.target&&e.target!==document&&e.target!==window){var el=e.target;while(el&&el!==document.body){var pos=window.getComputedStyle(el).position;if(pos==='fixed')return;el=el.parentElement}}setDocDropCar(null)};document.addEventListener('mousedown',h);window.addEventListener('scroll',s,true);return function(){document.removeEventListener('mousedown',h);window.removeEventListener('scroll',s,true)}},[]);

  var loadCarPhotos=function(carId){authFetch(API+'/cars/'+carId+'/photos').then(function(r){return r.json()}).then(function(d){if(d.success){setCarPhotos(function(p){var newPhotos=Object.assign({},p);newPhotos[carId]=d.photos||[];return newPhotos})}}).catch(function(){})};

  // 세금계산서 업로드 (차량 카드용)
  var uploadTaxInvoice=function(carId){
    var input=document.createElement('input');input.type='file';input.accept='image/*,.pdf';
    input.onchange=function(){
      var file=input.files[0];if(!file)return;
      var fd=new FormData();fd.append('file',file);fd.append('docType','tax_invoice');
      authFetch(API+'/cars/'+carId+'/upload-doc',{method:'POST',body:fd}).then(function(r){return r.json()}).then(function(d){
        if(d.success){showToast('세금계산서 업로드 완료');
          authFetch(API+'/cars/'+carId+'/docs').then(function(r){return r.json()}).then(function(docs){setCarDocs(function(prev){var n=Object.assign({},prev);n[carId]=docs;return n})}).catch(function(){});
        }else{showToast('업로드 실패','err');}
      }).catch(function(){showToast('서버 오류','err');});
    };
    input.click();
  };

  var dl=function(id,cn){
    if(user&&user.currentRole==='member'){showToast('삭제 권한은 owner에게만 있습니다','err');return;}
    setModal({type:'danger',title:'이 차량을 삭제할까요?',message:'['+cn+'] 차량과 관련 모든 데이터(서류, 사진, 경비, 장부, 말소대행, 인보이스 연결)가 삭제됩니다. 되돌릴 수 없습니다.',confirmText:'삭제',onConfirm:function(){
      closeModal();
      authFetch(API+'/cars/'+id,{method:'DELETE'}).then(function(r){return r.json()}).then(function(d){if(d.success){showToast('🗑️ '+cn+' 삭제 완료');ld()}else{showToast('삭제 실패: '+(d.error||''),'err')}}).catch(function(){showToast('삭제 실패','err')});
    }});
  };

  // D-day 계산 헬퍼
  var getDaysLeft=function(c){if(!c.export_deadline||c.status==='선적완료'||c.status==='등록완료'||c.status==='말소신청'||c.status==='폐차')return null;var now=new Date();var ddl=new Date(c.export_deadline);return Math.ceil((ddl-now)/(1000*60*60*24))};
  var deadlineCount=cars.filter(function(c){var d=getDaysLeft(c);return d!==null&&d<=30}).length;

  var filtered=cars.filter(function(c){
    if(filter==='기한임박'){var d=getDaysLeft(c);return d!==null&&d<=30}
    if(filter!=='전체'&&c.status!==filter)return false;
    if(buyerFilter!=='전체'&&String(c.buyerId)!==buyerFilter)return false;
    if(saleFilter!=='전체'&&(c.sale_status||'waiting')!==saleFilter)return false;
    if(search){var q=search.toLowerCase();return(c.carNo||'').toLowerCase().indexOf(q)!==-1||(c.vin||'').toLowerCase().indexOf(q)!==-1||(c.carType||'').toLowerCase().indexOf(q)!==-1||getEngCarName(c.carType||'').toLowerCase().indexOf(q)!==-1||(c.owner||'').toLowerCase().indexOf(q)!==-1}return true});

  // 정렬
  if(sortKey){
    filtered=filtered.slice().sort(function(a,b){
      var va,vb;
      if(sortKey==='carNo'){va=a.carNo||'';vb=b.carNo||'';return sortDir==='asc'?va.localeCompare(vb):vb.localeCompare(va)}
      if(sortKey==='year'){va=getYearFromVin(a.vin,a.regDate?parseInt(a.regDate.slice(0,4)):null)||0;vb=getYearFromVin(b.vin,b.regDate?parseInt(b.regDate.slice(0,4)):null)||0;}
      else if(sortKey==='mileage'){va=a.mileage||0;vb=b.mileage||0;}
      else if(sortKey==='buyPrice'){va=a.buyPrice||0;vb=b.buyPrice||0;}
      else if(sortKey==='invoice_amount'){va=a.invoice_amount||0;vb=b.invoice_amount||0;}
      else if(sortKey==='sellPrice'){va=a.sellPrice||0;vb=b.sellPrice||0;}
      else if(sortKey==='purchaseDate'){va=a.purchaseDate||a.buyDate||'';vb=b.purchaseDate||b.buyDate||'';return sortDir==='asc'?va.localeCompare(vb):vb.localeCompare(va)}
      else if(sortKey==='dday'){va=getDaysLeft(a);vb=getDaysLeft(b);if(va===null)va=9999;if(vb===null)vb=9999;}
      else{va=0;vb=0;}
      return sortDir==='asc'?(va-vb):(vb-va);
    });
  } else {
    // 기본: 최신 등록순 (id DESC) — 백엔드가 이미 내림차순으로 주지만 필터 후에도 보장
    filtered=filtered.slice().sort(function(a,b){return (b.id||0)-(a.id||0)});
  }

  var counts={total:cars.length};FLOW.forEach(function(f){counts[f]=cars.filter(function(c){return c.status===f}).length});

  // 페이지네이션
  var totalFiltered=filtered.length;
  var totalPages=perPage===0?1:Math.ceil(totalFiltered/perPage);
  if(page>totalPages&&totalPages>0)setPage(totalPages);
  var pagedFiltered=perPage===0?filtered:filtered.slice((page-1)*perPage,page*perPage);
  var startIdx=perPage===0?1:(page-1)*perPage+1;
  var endIdx=perPage===0?totalFiltered:Math.min(page*perPage,totalFiltered);

  var toggleSort=function(key){if(sortKey===key){setSortDir(sortDir==='asc'?'desc':'asc')}else{setSortKey(key);setSortDir('asc')}};
  var sortArrow=function(key){if(sortKey!==key)return ' ↕';return sortDir==='asc'?' ▲':' ▼'};

  // 스크롤 감지
  useEffect(function(){
    var container=document.querySelector('.dash-content');
    if(!container)return;
    var onScroll=function(){setShowScrollTop(container.scrollTop>300)};
    container.addEventListener('scroll',onScroll);
    return function(){container.removeEventListener('scroll',onScroll)};
  },[]);

  var[statusDdCar,setStatusDdCar]=useState(null);
  var ns=function(c){setStatusDdCar(function(prev){return prev&&prev.id===c.id?null:c})};
  var changeStatus=function(c,newStatus){
    if(c.status===newStatus){setStatusDdCar(null);return;}
    // 말소신청 → 등록완료 되돌림: 이미 신청한 말소 대행이 취소됨을 안내 (대행업체에도 취소 통보)
    var isMalsoRevert=(c.status==='말소신청'&&newStatus==='등록완료');
    var doChange=function(){
      closeModal();
      authFetch(API+'/cars/'+c.id+'/status',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({status:newStatus})}).then(function(){showToast(isMalsoRevert?'말소 신청이 취소되었습니다':'✅ '+newStatus);setStatusDdCar(null);ld()});
    };
    if(isMalsoRevert){
      setModal({type:'danger',title:'이미 신청한 말소를 취소하시겠습니까?',message:c.carNo+' — 등록 상태로 되돌리면 진행 중인 말소 대행 신청이 취소되고, 배정된 말소대행업체에도 취소 안내가 전달됩니다.',confirmText:'네, 취소합니다',cancelText:'아니요',onConfirm:doChange});
    } else {
      setModal({type:'confirm',title:'상태를 변경할까요?',message:c.carNo+' → '+newStatus,onConfirm:doChange});
    }
  };

  var toggleCheck=function(id){setCheckedIds(function(p){return p.includes(id)?p.filter(function(x){return x!==id}):[...p,id]})};
  var checkedCars=cars.filter(function(c){return checkedIds.includes(c.id)});

  var uploadPhoto=function(carId){var input=document.getElementById('photo-input-'+carId);if(input)input.click()};
  var handleMultiPhotoSelect=function(carId,files){if(!files||files.length===0)return;var uploadCount=0;var successCount=0;Array.from(files).forEach(function(file,idx){setUploadingPhotoId(carId);var fd=new FormData();fd.append('photo',file);authFetch(API+'/cars/'+carId+'/photos',{method:'POST',body:fd}).then(function(r){return r.json()}).then(function(d){uploadCount++;if(d.success){successCount++}if(uploadCount===files.length){showToast(successCount+'/'+uploadCount+'장 업로드 완료!');loadCarPhotos(carId);ld();setUploadingPhotoId(null)}}).catch(function(err){uploadCount++;if(uploadCount===files.length){showToast(successCount+'장 업로드, 실패 '+(files.length-successCount)+'장','err');loadCarPhotos(carId);setUploadingPhotoId(null)}})})};

  var deletePhoto=function(photoId,carId){
    setModal({type:'danger',title:'사진을 삭제할까요?',confirmText:'삭제',onConfirm:function(){
      closeModal();
      authFetch(API+'/photos/'+photoId,{method:'DELETE'}).then(function(r){return r.json()}).then(function(d){if(d.success){showToast('🗑️ 삭제됨');loadCarPhotos(carId)}}).catch(function(){showToast('삭제 실패','err')});
    }});
  };

  var togglePublic=function(c){var newPublic=!c.isPublic;authFetch(API+'/cars/'+c.id+'/toggle-public',{method:'PATCH',headers:{'Content-Type':'application/json'},body:JSON.stringify({isPublic:newPublic})}).then(function(r){return r.json()}).then(function(d){if(d.success){showToast(newPublic?'🌐 공개':'🔒 비공개');ld()}}).catch(function(){showToast('오류','err')})};

  // 현장 계약서 출력
  var[contractCompany,setContractCompany]=useState(null);
  var openContract=function(carOrCars){var arr=Array.isArray(carOrCars)?carOrCars:[carOrCars];setContractCars(arr);
    var initPrices={};arr.forEach(function(c){if(c.sellPrice&&Number(c.sellPrice)>0){initPrices[c.id]=String(manFromWon(c.sellPrice))}});
    // 매수인 prefill — 다중 선택은 buyerId 가 모두 동일할 때만 (불일치면 빈칸 유지)
    var firstBid=arr[0]&&arr[0].buyerId?Number(arr[0].buyerId):0;
    var allSameBuyer=firstBid>0&&arr.every(function(c){return Number(c.buyerId||0)===firstBid});
    setContractPrices(initPrices);
    setContractBuyerName(allSameBuyer?(arr[0].buyerName||''):'');
    setContractBuyerPhone(allSameBuyer?(arr[0].buyerTel||''):'');
    setContractDeposit('');
    var cid=arr[0]?arr[0].companyId:0;
    authFetch(API+'/settings/company'+(cid?'?companyId='+cid:'')).then(function(r){return r.json()}).then(function(d){setContractCompany(d)}).catch(function(){setContractCompany(null)});
  };
  var closeContract=function(){setContractCars([]);setContractPrices({});setContractBuyerName('');setContractBuyerPhone('');setContractDeposit('')};
  // carNameMap/getEngCarName → utils/carNames.js로 통합 (3단계 리팩토링)
  var saveContractData=function(skipClose){
    if(contractCars.length===0)return;
    var hasPrice=contractCars.some(function(c){return contractPrices[c.id]});
    if(!hasPrice){showToast('인보이스 금액을 1대 이상 입력해주세요','err');return}
    localStorage.setItem('contract_bankInfo',contractBankInfo);
    localStorage.setItem('contract_docPhone',contractDocPhone);
    var depositMan2=Number(contractDeposit)||0;
    var depositWon2=wonFromMan(depositMan2);
    var buyerPromise;
    if(contractBuyerName){
      var existBuyer=editBuyers.find(function(b){return b.name===contractBuyerName});
      if(existBuyer){buyerPromise=Promise.resolve(existBuyer.id)}
      else{buyerPromise=authFetch(API+'/buyers',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({name:contractBuyerName,tel:contractBuyerPhone||''})}).then(function(r){return r.json()}).then(function(d){return d.id||0})}
    }else{buyerPromise=Promise.resolve(0)}
    buyerPromise.then(function(buyerId){
      // 각 차량의 PATCH/PUT + 현장계약서 PDF 생성(sales-contract/save) 을 puts 배열에 수집
      // Promise.all 로 모두 완료 후 목록 리로드 (race fix + PDF 서류함 저장)
      var puts=[];var failed=[];// PUT 실패(409 포함) 서버 문구 — 건수 안내
      // 현장계약서 PDF 저장 (저장 버튼 / 출력 버튼 양쪽에서 호출됨 — idempotent overwrite)
      var savePrices={};
      contractCars.forEach(function(c){savePrices[String(c.id)]=Number(contractPrices[c.id])||0});
      puts.push(authFetch(API+'/sales-contract/save',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({
        carIds:contractCars.map(function(c){return c.id}),
        prices:savePrices,
        buyerName:contractBuyerName,
        buyerPhone:contractBuyerPhone,
        bankInfo:contractBankInfo,
        docPhone:contractDocPhone,
        deposit:depositWon2,
        companyId:contractCars[0]?contractCars[0].companyId:0
      })}).then(function(r){return r.json()}).catch(function(){return null}));
      contractCars.forEach(function(c){
        // 판매가는 실제로 바꿨을 때만 (열 때 값은 만원 반올림 — 그대로 보내면 원 단위 손실 + PATCH 가 USD/환율 리셋)
        var newMan=Number(contractPrices[c.id])||0;
        var priceChanged=newMan>0&&newMan!==(Number(c.sellPrice)>0?manFromWon(c.sellPrice):0);
        var carSellPrice=priceChanged?wonFromMan(newMan):(Number(c.sellPrice)||0);
        var carDeposit=contractCars.length===1?depositWon2:0;
        var ps='unpaid';
        if(carDeposit>0&&carSellPrice>0&&carDeposit>=carSellPrice)ps='paid';
        else if(carDeposit>0)ps='partial';
        if(priceChanged)puts.push(authFetch(API+'/cars/'+c.id+'/sell-price',{method:'PATCH',headers:{'Content-Type':'application/json'},body:JSON.stringify({sellPrice:carSellPrice})}).catch(function(){}));
        // 목록 행 전체 대신 이 동작이 바꾸는 키만 + 낙관적 락 version
        var updateBody={sale_status:(c.sale_status==='paid')?'paid':'contracted'};
        if(buyerId)updateBody.buyerId=buyerId;
        if(carDeposit>0){updateBody.deposit=carDeposit;updateBody.payment_status=ps}
        if(priceChanged)updateBody.sellPrice=carSellPrice;
        if(c.version!==undefined&&c.version!==null)updateBody.version=c.version;
        puts.push(authFetch(API+'/cars/'+c.id,{method:'PUT',headers:{'Content-Type':'application/json'},body:JSON.stringify(updateBody)}).then(function(r){return r.json()}).then(function(d){if(!(d&&d.success))failed.push((d&&d.error)||'')}).catch(function(){failed.push('')}));
      });
      Promise.all(puts).then(function(){
        ld();if(failed.length)showToast('차량 '+failed.length+'대 저장 실패'+(failed[0]?' — '+failed[0]:''),'err');else showToast('차량정보 저장 완료');
        if(!skipClose)closeContract();
      });
    }).catch(function(){showToast('저장 실패','err')});
  };
  // printContract → utils/contractPrint.js로 이동. 호출 시점에 현재 폼 상태 스냅샷을 전달.
  var printContract=function(){
    printContractUtil({
      contractCars:contractCars,contractPrices:contractPrices,contractDeposit:contractDeposit,
      contractBuyerName:contractBuyerName,contractBuyerPhone:contractBuyerPhone,
      contractBankInfo:contractBankInfo,contractDocPhone:contractDocPhone,
      contractCompany:contractCompany,companyInfo:companyInfo,
      setModal:setModal,closeModal:closeModal,
      saveContractData:saveContractData,closeContract:closeContract
    });
  };

  // 말소 대행 신청 팝업 열기
  var openCancelReq=function(car){
    setCancelReqCar(car);setCrAgencyId('');setCrFee('');setCrMemo('');setCrCancelType('수출말소');setCrSubmitting(false);setCrServices([]);
    authFetch(API+'/cancel-agencies').then(function(r){return r.json()}).then(function(d){setCrAgencies((d||[]).filter(function(a){return a.active}))}).catch(function(){});
  };
  var closeCancelReq=function(){setCancelReqCar(null)};
  var submitCancelReq=function(){
    if(!cancelReqCar)return;
    if(!crAgencyId){showToast('대행업체를 선택하세요','err');return;}
    setCrSubmitting(true);
    var hasReissueService=crServices.some(function(s){return s.kind==='reissue'});
    var body={carId:cancelReqCar.id,agencyId:crAgencyId?parseInt(crAgencyId):null,fee:parseInt(crFee)||0,memo:crMemo,requestDate:new Date().toISOString().slice(0,10),cancelType:crCancelType};
    if(hasReissueService)body.needsReissue=1;
    if(crServices.length)body.services=crServices.map(function(s){var o={serviceId:s.serviceId};if(s.memo)o.memo=s.memo;return o;});
    authFetch(API+'/cancel-requests',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)}).then(function(r){return r.json()}).then(function(d){
      if(d.success){
        if(d.lien&&d.lien.status==='has_lien'){showToast('⚠️ 압류/저당 감지 — '+(d.lien.detail||'')+' / 해소 후 말소 진행 가능 (대행업체 보류 처리)','err');}
        else showToast('말소 대행 신청 완료');
        closeCancelReq();ld();
      }
      else{showToast(d.error||'신청 실패','err');setCrSubmitting(false);}
    }).catch(function(){showToast('서버 오류','err');setCrSubmitting(false);});
  };

  // #337: 이월 배지 판정용 조회월 — 검색 중이거나 월필터 비활성이면 null(배지 없음)
  var _searchingNow=(search||'').trim().length>0;
  var carryOverMonth=(!_searchingNow && monthFilter && /^\d{4}-\d{2}$/.test(monthFilter))?monthFilter:null;

  return(<div style={showCompanyFilter?{display:'flex',gap:16,alignItems:'flex-start'}:undefined}>
    {showCompanyFilter&&<CompanyListPanel user={user} context="invoice" month="" selectedCompanyId={filterCompanyId} onSelect={function(id){setFilterCompanyId(id);setAllCompanyMode(!id)}}/>}
    <div style={showCompanyFilter?{flex:1,minWidth:0}:undefined}>
    {uploadCar&&<UploadPopup car={uploadCar} onClose={function(){setUploadCar(null)}} onDone={function(newStatus,docName,matchedBy){setUploadCar(null);if(newStatus)showToast('✅ '+newStatus+' 자동 진입! ('+(docName||'서류')+' 검증완료)');else showToast('📎 '+(docName||'서류')+' 업로드 완료'+(matchedBy?' ('+matchedBy+' 일치)':''));ld();}}/>}
    <CarListModals
      editCar={editCar} setEditCar={setEditCar} editForm={editForm} editBaseForm={editBaseForm} ef={ef} reloadEditCar={reloadEditCar}
      editOwnerIdFront={editOwnerIdFront} setEditOwnerIdFront={setEditOwnerIdFront}
      editOwnerIdBack={editOwnerIdBack} setEditOwnerIdBack={setEditOwnerIdBack}
      editOwner2IdFront={editOwner2IdFront} setEditOwner2IdFront={setEditOwner2IdFront}
      editOwner2IdBack={editOwner2IdBack} setEditOwner2IdBack={setEditOwner2IdBack}
      editBuyers={editBuyers} setEditBuyers={setEditBuyers} editTimeline={editTimeline}
      editSaving={editSaving} setEditSaving={setEditSaving} saveEditCar={saveEditCar}
      presenceBanner={editCar?presenceBanner(editCar.id):null}
      cancelReqCar={cancelReqCar} closeCancelReq={closeCancelReq}
      crAgencies={crAgencies} crAgencyId={crAgencyId} setCrAgencyId={setCrAgencyId}
      crFee={crFee} setCrFee={setCrFee} crMemo={crMemo} setCrMemo={setCrMemo}
      crCancelType={crCancelType} setCrCancelType={setCrCancelType}
      crServices={crServices} setCrServices={setCrServices}
      crSubmitting={crSubmitting} submitCancelReq={submitCancelReq}
      selectedPhotosCar={selectedPhotosCar} setSelectedPhotosCar={setSelectedPhotosCar}
      carPhotos={carPhotos} setCarPhotos={setCarPhotos}
      dragPhotoIdx={dragPhotoIdx} setDragPhotoIdx={setDragPhotoIdx}
      dragOverIdx={dragOverIdx} setDragOverIdx={setDragOverIdx}
      deletePhoto={deletePhoto} uploadPhoto={uploadPhoto}
      docDetailCar={docDetailCar} setDocDetailCar={setDocDetailCar}
      carDocs={carDocs} setCarDocs={setCarDocs}
      downloadServerDoc={downloadServerDoc} showToast={showToast}
      clearDocModal={clearDocModal} setClearDocModal={setClearDocModal}
      clearDocTab={clearDocTab} setClearDocTab={setClearDocTab}
      clearDocData={clearDocData} setClearDocData={setClearDocData}
      clearDocLoading={clearDocLoading} setClearDocLoading={setClearDocLoading}
      clearDocEmail={clearDocEmail} setClearDocEmail={setClearDocEmail}
      clearDocSending={clearDocSending} setClearDocSending={setClearDocSending}
      companyInfo={companyInfo} companiesList={companiesList} user={user}
      contractCars={contractCars} closeContract={closeContract}
      contractPrices={contractPrices} setContractPrices={setContractPrices}
      contractBuyerName={contractBuyerName} setContractBuyerName={setContractBuyerName}
      contractBuyerPhone={contractBuyerPhone} setContractBuyerPhone={setContractBuyerPhone}
      contractDeposit={contractDeposit} setContractDeposit={setContractDeposit}
      contractBankInfo={contractBankInfo} setContractBankInfo={setContractBankInfo}
      contractDocPhone={contractDocPhone} setContractDocPhone={setContractDocPhone}
      contractCompany={contractCompany} setContractCompany={setContractCompany}
      printContract={printContract} saveContractData={saveContractData}
    />

    <CarListToolbar
      search={search} setSr={setSr} ld={ld} viewMode={viewMode} setViewMode={setViewMode}
      checkedIds={checkedIds} setCheckedIds={setCheckedIds} filtered={filtered} checkedCars={checkedCars}
      openInvoice={openInvoice} openContract={openContract}
      bulkDlOpen={bulkDlOpen} setBulkDlOpen={setBulkDlOpen} bulkDlLoading={bulkDlLoading} setBulkDlLoading={setBulkDlLoading}
      bulkDlChecked={bulkDlChecked} setBulkDlChecked={setBulkDlChecked}
      FLOW={FLOW} FLOW_COLOR={FLOW_COLOR} filter={filter} setFl={setFl}
      buyerFilter={buyerFilter} setBuyerFilter={setBuyerFilter} buyerList={buyerList}
      monthFilter={monthFilter} setMonthFilter={setMonthFilter}
      includeCarryOver={includeCarryOver} setIncludeCarryOver={setIncludeCarryOver}
      saleFilter={isAgency?undefined:saleFilter} setSaleFilter={isAgency?undefined:setSaleFilter}
      counts={counts} deadlineCount={deadlineCount} page={page} setPage={setPage}
      perPage={perPage} setPerPage={setPerPage} totalFiltered={totalFiltered}
      startIdx={startIdx} endIdx={endIdx} showToast={showToast} user={user}
    />

    {user&&user.role!=='대행업체'&&<div style={{display:'flex',gap:6,marginBottom:8}}><button onClick={function(){setAllCompanyMode(false)}} style={{padding:'5px 12px',borderRadius:6,border:'1px solid '+(allCompanyMode?'#d0d5dd':'#1B3A5C'),background:allCompanyMode?'#fff':'#1B3A5C',color:allCompanyMode?'#555':'#fff',fontSize:11,fontWeight:600,cursor:'pointer'}}>현재 업체</button><button onClick={function(){setAllCompanyMode(true)}} style={{padding:'5px 12px',borderRadius:6,border:'1px solid '+(allCompanyMode?'#1B3A5C':'#d0d5dd'),background:allCompanyMode?'#1B3A5C':'#fff',color:allCompanyMode?'#fff':'#555',fontSize:11,fontWeight:600,cursor:'pointer'}}>전체 업체</button></div>}

    {!isAgency&&(function(){var pubN=(cars||[]).filter(function(c){return c.isPublic}).length;return(
      <div style={{display:'flex',alignItems:'center',gap:6,marginBottom:8,fontSize:12,color:'#475569'}}>
        <span style={{display:'inline-flex',alignItems:'center',gap:4,padding:'3px 10px',borderRadius:999,background:pubN>0?'#dcfce7':'#f1f5f9',color:pubN>0?'#166534':'#94a3b8',fontWeight:700}}>🌐 전체매물 노출중 {pubN}대</span>
        <span style={{color:'#94a3b8'}}>공개(🌐) 토글 시 외부 바이어 전체매물에 노출됩니다</span>
      </div>);
    })()}

    {viewMode==='card'?(<CarListCards
      cars={cars} filtered={filtered} FLOW={FLOW} FLOW_COLOR={FLOW_COLOR}
      checkedIds={checkedIds} toggleCheck={toggleCheck} carPhotos={carPhotos}
      hasDoc={hasDoc} downloadServerDoc={downloadServerDoc} getDaysLeft={getDaysLeft}
      ns={ns} statusDdCar={statusDdCar} setStatusDdCar={setStatusDdCar} changeStatus={changeStatus}
      openEditCar={openEditCar} dl={dl} togglePublic={togglePublic}
      uploadPhoto={uploadPhoto} handleMultiPhotoSelect={handleMultiPhotoSelect}
      setSelectedPhotosCar={setSelectedPhotosCar} openCancelReq={openCancelReq}
      uploadTaxInvoice={uploadTaxInvoice} showToast={showToast} ld={ld} carDocs={carDocs}
      openContract={openContract} carryOverMonth={carryOverMonth} othersForCar={othersForCar}
    />):(<CarListTable
      pagedFiltered={pagedFiltered} FLOW={FLOW} FLOW_COLOR={FLOW_COLOR}
      checkedIds={checkedIds} setCheckedIds={setCheckedIds} toggleCheck={toggleCheck}
      carPhotos={carPhotos} hasDoc={hasDoc} getDaysLeft={getDaysLeft} ns={ns}
      statusDdCar={statusDdCar} setStatusDdCar={setStatusDdCar} changeStatus={changeStatus}
      openEditCar={openEditCar} dl={dl} setSelectedPhotosCar={setSelectedPhotosCar}
      uploadPhoto={uploadPhoto} handleMultiPhotoSelect={handleMultiPhotoSelect}
      openCancelReq={openCancelReq} setDocDropCar={setDocDropCar}
      docDropCar={docDropCar} docDropPos={docDropPos} setDocDropPos={setDocDropPos}
      setDocDetailCar={setDocDetailCar} carDocs={carDocs}
      toggleSort={toggleSort} sortArrow={sortArrow} sortKey={sortKey}
      page={page} perPage={perPage} downloadServerDoc={downloadServerDoc}
      openContract={openContract} carryOverMonth={carryOverMonth}
      allCompanyMode={allCompanyMode} togglePublic={togglePublic}
      ld={ld} user={user} othersForCar={othersForCar}
    />)}
    
    {/* 페이지네이션 하단 */}
    {perPage>0&&totalPages>1&&<div style={{display:'flex',justifyContent:'center',alignItems:'center',gap:4,marginTop:16,padding:'12px 0'}}>
      <button style={{padding:'6px 14px',borderRadius:6,fontSize:13,fontWeight:600,border:'1px solid #d0d5dd',background:page<=1?'#f8fafc':'#fff',color:page<=1?'#cbd5e1':'#334155',cursor:page<=1?'default':'pointer'}} disabled={page<=1} onClick={function(){setPage(page-1)}}>이전</button>
      {(function(){
        var pages=[];var start=Math.max(1,page-2);var end=Math.min(totalPages,page+2);
        if(start>1){pages.push(1);if(start>2)pages.push('...')}
        for(var i=start;i<=end;i++)pages.push(i);
        if(end<totalPages){if(end<totalPages-1)pages.push('...');pages.push(totalPages)}
        return pages.map(function(p,pi){
          if(p==='...')return(<span key={'dot'+pi} style={{padding:'6px 4px',fontSize:13,color:'#94a3b8'}}>...</span>);
          var isActive=p===page;
          return(<button key={p} style={{padding:'6px 12px',borderRadius:6,fontSize:13,fontWeight:isActive?700:500,border:'1px solid '+(isActive?'#3b82f6':'#d0d5dd'),background:isActive?'#2563eb':'#fff',color:isActive?'#fff':'#334155',cursor:'pointer',minWidth:36}} onClick={function(){setPage(p)}}>{p}</button>);
        });
      })()}
      <button style={{padding:'6px 14px',borderRadius:6,fontSize:13,fontWeight:600,border:'1px solid #d0d5dd',background:page>=totalPages?'#f8fafc':'#fff',color:page>=totalPages?'#cbd5e1':'#334155',cursor:page>=totalPages?'default':'pointer'}} disabled={page>=totalPages} onClick={function(){setPage(page+1)}}>다음</button>
    </div>}

    {/* 맨 위로 가기 */}
    {showScrollTop&&<button onClick={function(){var el=document.querySelector('.dash-content');if(el)el.scrollTo({top:0,behavior:'smooth'})}} style={{position:'fixed',bottom:30,right:30,width:44,height:44,borderRadius:'50%',background:'linear-gradient(135deg,#1e40af,#3b82f6)',color:'#fff',border:'none',fontSize:18,fontWeight:700,cursor:'pointer',boxShadow:'0 4px 16px rgba(59,130,246,0.4)',zIndex:999,display:'flex',alignItems:'center',justifyContent:'center',transition:'opacity .2s'}}>↑</button>}
    {modal&&<CustomModal isOpen={true} {...modal} onCancel={closeModal} />}
    </div>
  </div>);
}

export default CarListPage;
